import InAppReview from "react-native-in-app-review";
import DeviceInfo from "react-native-device-info";
import Analytics from "@services/analytics";
import { IN_APP_RATING_ERROR } from "@constants/analyticsEvents";
import { AppState } from "react-native";
import Share from "react-native-share";

const invokeAppRating = (handler) => {
  DeviceInfo.isEmulator()
    .then((isEmulator) => {
      if (!isEmulator) {
        Share.isPackageInstalled("com.android.vending").then(
          ({ isInstalled }) => {
            if (isInstalled && InAppReview.isAvailable()) {
              setTimeout(() => {
                AppState.removeEventListener("change", handler);
              }, 2000);
              InAppReview.RequestInAppReview().catch((e) => {
                Analytics.trackEvent(IN_APP_RATING_ERROR, {
                  error: JSON.stringify(e),
                });
              });
            }
          },
        );
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
export default invokeAppRating;
